/**
 * @Description This is FasatRouterLink component page.
 * This is a wrapper on react-router-dom "Link" component from
 * MUX without adding any custom functionlities
 * @FileName fasaRoutertLink.js
 * @Author Samiran Das- dasamir
 * @CreatedOn 3 June, 2021 20:08:00
 */
import React from 'react';
import { Link } from 'react-router-dom';
import './fasatRouterLink.scss';

function FasatRouterLink(props) {
  const to = props?.to?.pathname || props.to;
  const state = props?.to?.state || props.state;
  return (
    <span className="fasatRouterLink">
      <Link {...props} to={to} state={state}>{props.children}</Link>
    </span>
  );
}

export default FasatRouterLink;
